// extracted by mini-css-extract-plugin
export var closeButton = "_nh-2";
export var closeButtonIcon = "_nh-3";
export var lightboxContent = "_nh-1";
export var lightboxOverlay = "_nh-0";